import { render, staticRenderFns } from "./drawerSlider.vue?vue&type=template&id=5b62ff4f&"
import script from "./drawerSlider.vue?vue&type=script&lang=js&"
export * from "./drawerSlider.vue?vue&type=script&lang=js&"
import style0 from "./drawerSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports